/**
 * useAudience — audiencia efectiva del usuario (Fiado SA vs UNE-Credito) derivada del
 * rol RBAC + el override del switcher. Reemplaza el ternario legacy por
 * `customFields.typeOfDirectoryId` que estaba duplicado en AppLayout/Header/Sidebar/Candidatos.
 * Ver DEC/TD-CRED-001 y `@/lib/audience`.
 */
import { useAppStore } from '@/stores/app.store';
import { useAuthStore } from '@/stores/auth.store';
import { resolveAudience, canSwitchAudience, type Audience } from '@/lib/audience';

export function useAudience(): { resolvedRole: Audience; canSwitchRole: boolean } {
  const activeRole = useAppStore((s) => s.activeRole);
  const roleAssignments = useAuthStore((s) => s.roleAssignments);

  return {
    resolvedRole: resolveAudience(activeRole, roleAssignments),
    // El switcher solo si tenés AMBOS roles (une_fiadosa + une_partner).
    canSwitchRole: canSwitchAudience(roleAssignments),
  };
}
